import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { IconBadge } from "./Ui";

export const ServiceCard = ({ s, featured = false, wide = false, i = 0 }) => (
  <Reveal delay={(i % 4) * 0.06} className={`${featured ? "md:col-span-2 md:row-span-2" : ""} ${wide ? "md:col-span-2" : ""}`}>
    <Link to={`/solutions#${s.slug}`} data-testid={`service-card-${s.slug}`}
      className={`group relative flex h-full flex-col overflow-hidden rounded-2xl p-7 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 ${featured
        ? "bg-[#102B50] text-white shadow-[0_20px_50px_rgba(16,43,80,0.25)]"
        : "card-soft"}`}>
      {featured && <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[#2878E5]/40 blur-[90px]" />}
      {featured && <s.icon className="pointer-events-none absolute -right-6 top-16 hidden h-56 w-56 text-white/[0.06] transition-transform duration-700 group-hover:rotate-12 md:block" strokeWidth={1} />}
      <div className="relative flex items-start justify-between">
        <IconBadge icon={s.icon} dark={featured} />
        <ArrowUpRight className={`h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 ${featured ? "text-white/70" : "text-slate-400 group-hover:text-[#2878E5]"}`} />
      </div>
      <h3 className={`relative mt-auto pt-10 font-display font-bold tracking-tight ${featured ? "text-3xl lg:text-4xl" : "text-xl text-[#102B50]"}`}>{s.title}</h3>
      <p className={`relative mt-3 text-[15px] leading-relaxed ${featured ? "max-w-md text-slate-300" : "text-[#4A5D78]"}`}>{featured ? s.long : s.short}</p>
    </Link>
  </Reveal>
);

export const VerticalCard = ({ v, i = 0 }) => (
  <Reveal delay={(i % 3) * 0.08} className="h-full">
    <Link to={`/verticals#${v.slug}`} data-testid={`vertical-card-${v.slug}`} className="card-soft group block h-full overflow-hidden">
      <div className="aspect-[4/3] overflow-hidden bg-[#F4F7FB]">
        <img src={v.img} alt={`${v.title} illustration`} loading="lazy" width="640" height="640" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between">
          <h3 className="font-display text-xl font-bold text-[#102B50]">{v.title}</h3>
          <ArrowUpRight className="h-5 w-5 text-slate-400 transition-colors group-hover:text-[#2878E5]" />
        </div>
        <p className="mt-2 text-[15px] leading-relaxed text-[#4A5D78]">{v.text}</p>
      </div>
    </Link>
  </Reveal>
);
